var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[[_c('v-col',{attrs:{"cols":"12"}},[_c('pendingProfile')],1),_c('v-col',{staticClass:"pt-8 d-flex justify-space-between",attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"depressed":"","color":"primary","to":{ name: 'convocation'}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-arrow-left ")]),_vm._v(" Volver ")],1),_c('v-spacer')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }